/**
 * Report Registry
 * 
 * Central registry of all available report modules and workbooks.
 * Import each report definition and add it to the REPORTS array.
 * Workbooks have isWorkbook: true and appear under the 'Workbooks' category.
 */

import apAgingReport from './apAging';
import arAgingReport from './arAging';
import cashFlowReport from './cashFlowForecast';
import commitmentDetailReport from './commitmentDetail';
import receivablesDetailReport from './receivablesDetail';
import openApBillsDiscount from './openApBillsDiscount';
import jobCostDetail from './jobCostDetail';
import projectWorkbook from './projectWorkbook';

const REPORTS = [
  apAgingReport,
  arAgingReport,
  cashFlowReport,
  commitmentDetailReport,
  receivablesDetailReport,
  openApBillsDiscount,
  jobCostDetail,
  projectWorkbook,
];

export const getReportCategories = () => {
  const cats = [...new Set(REPORTS.map(r => r.category))].sort();
  return ['All', ...cats];
};

export const getReportsByCategory = (category) => {
  if (!category || category === 'All') return REPORTS;
  return REPORTS.filter(r => r.category === category);
};

export const getReportById = (id) => {
  return REPORTS.find(r => r.id === id) || null;
};

export default REPORTS;